<template>
    <Button class="followButton"
        :appearance="followButton.appearance"
        :prefixIcon="followButton.icon"
        :disabled="disableFollowAction"
        size="small"
        @click="handleFollow">
        {{ followButton.label }}
    </Button>
</template>

<script>
    import { db } from '@/firebase'
    import { mapActions } from 'vuex'
    import firebase from 'firebase/app'

    export default {
        name: 'FollowButton',
        data() {
            return {
                disableFollowAction: false
            }
        },
        props: {
            followers: {
                type: Array,
                required: true
            },
            currentUserID: {
                type: String,
                required: true
            }
        },
        computed: {
            isFollowing() {
                if(this.auth.id) {
                    return this.followers.includes(this.auth.id)
                } else {
                    return false
                }
            },
            followButton() {
                if(this.isFollowing) {
                    return {
                        label: this.siteContent.following,
                        appearance: 'green',
                        icon: 'how_to_reg'
                        }
                } else {
                    return {
                        label: this.siteContent.follow,
                        appearance: 'cta',
                        icon: 'person_add_alt'
                    }
                }
            }
        },
        methods: {
            ...mapActions('notifications',['createNotification']),

            async handleFollow() {
                if(this.isFollowing) {
                    try {
                        this.disableFollowAction = true
                        // Remove from follower list
                        await db
                            .collection('users')
                            .doc(this.currentUserID)
                            .collection('social')
                            .doc('followers')
                            .update({
                                users: firebase.firestore.FieldValue.arrayRemove(this.auth.id)
                            })

                        // Remove from following list
                        await db
                            .collection('users')
                            .doc(this.auth.id)
                            .collection('social')
                            .doc('following')
                            .update({
                                users: firebase.firestore.FieldValue.arrayRemove(this.currentUserID)
                            })
                        this.disableFollowAction = false
                    } catch(error) {
                        console.log(error)
                    }
                } else {
                    try {
                        this.disableFollowAction = true
                        // Add to follower list
                        await db
                            .collection('users')
                            .doc(this.currentUserID)
                            .collection('social')
                            .doc('followers')
                            .update({
                                users: firebase.firestore.FieldValue.arrayUnion(this.auth.id)
                            })

                        // Add to following list
                        await db
                            .collection('users')
                            .doc(this.auth.id)
                            .collection('social')
                            .doc('following')
                            .update({
                                users: firebase.firestore.FieldValue.arrayUnion(this.currentUserID)
                            })
                        this.disableFollowAction = false
                    } catch(error) {
                        console.log(error)
                    }

                    // Create notification
                    try {
                        var notification = {
                            type:       'newFollower',
                            docID:       this.loggedInUser.slug,
                            createdBy:   this.auth.id,
                            timestamp:   new Date(),
                            recipients:  [ this.currentUserID ]
                        }

                        await this.createNotification({
                            notification: notification
                        })
                    } catch(err) {
                        console.log(err)
                    }
                }
            }
        }
    }
</script>